// ======================================================================
// File Name       : DistributionReportSearch
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { Form, Col, Button } from 'react-bootstrap';
import RenderField from '../../../utils/ReduxFormUtils';
import { REPORT_STATUS_SUBMITTED } from '../../../constants/KeyValueConstants';
import * as distributionAction from '../../../actions/report/DistributionAction';
import CustomButton from '../../button/CustomButton';

class DistributionReportSearch extends React.Component {
  constructor(props) {
    super(props);
    this.onSearchData = this.onSearchData.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
  }
  /**
   * Get distribution report list when click button search
   */
  onSearchData() {
    this.props.updateShowSearchMessageFlag(false);
    const { dispatch, distributionReport } = this.props;
    const { distributionReportList } = distributionReport;
    const { searchInfo } = distributionReportList;
    searchInfo.startPosition = 0;
    dispatch(distributionAction.updateDistributionReportSearchInfo(searchInfo));
    dispatch(distributionAction.searchDistributionReport()).then(() => {
      this.props.updateShowSearchMessageFlag(true);
    });
  }

  /**
     * Pagination
     * @param {*} startPosition
     */
  getStartEndData(startPosition) {
    const { dispatch, distributionReport } = this.props;
    const { distributionReportList } = distributionReport;
    const { searchInfo } = distributionReportList;
    searchInfo.startPosition = startPosition;
    dispatch(distributionAction.updateDistributionReportSearchInfo(searchInfo));
    dispatch(distributionAction.searchDistributionReport());
  }

  render() {
    const { dispatch, distributionReport } = this.props;
    const { distributionReportList } = distributionReport;
    const { searchInfo, distributionReports } = distributionReportList;
    return (
      <div>
        <p className="margin-top-10">検索する項目を指定してください</p>
        <Col sm={12} className="padding-top-10">
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              this.onSearchData();
            }}
            className='form-horizontal'
          >
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={4}>
                レポート名
              </Col>
              <Col sm={7}>
                <RenderField type="text" name="reportName" label="レポート名" maxLength="256" />
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col htmlFor="includeDeadlineReportFlg" as={Form.Label} sm={4}>
                提出期限切れレポートを含む
              </Col>
              <Col sm={7} className="padding-top-10">
                <RenderField
                  type="checkbox"
                  name="includeDeadlineReportFlg"
                  className="padding-top-clear"
                />
              </Col>
            </Form.Group>
            <Form.Group className="margin-top-20 text-center form-group">
              <Col sm={12}>
                <CustomButton
                  btnStyle="btn btn-primary btn-96"
                  type="submit"
                  text="検索"
                  iconClass="bi bi-search"
                />
              </Col>
            </Form.Group>
          </Form>
        </Col>
        <Col sm={12} className="padding-left-right-clear">
          <Form className='form-horizontal'>
            <Col sm={12} className="padding-left-right-clear">
              <Col sm={5} className="padding-left-right-clear margin-top-30 margin-bottom-20">
                分配レポート一覧
              </Col>
            </Col>
          </Form>
        </Col>
      </div>
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  const { form, distributionReport } = state;
  return {
    distributionReport,
  };
};

const form = reduxForm({ form: 'distributionReportSearchForm', touchOnChange: true });
export default connect(mapStateToProps)(form(DistributionReportSearch));
